import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock } from 'lucide-react';

const STATUS_CONFIG = {
  open: { label: 'Deschis', color: 'bg-blue-500 text-white', icon: Clock },
  accepted: { label: 'Acceptat', color: 'bg-amber-500 text-white', icon: Clock },
  in_progress: { label: 'In Lucru', color: 'bg-purple-500 text-white', icon: Clock },
  waiting_parts: { label: 'Asteapta Piese', color: 'bg-orange-500 text-white', icon: Clock },
  monitoring: { label: 'Sub Monitorizare', color: 'bg-yellow-500 text-slate-900', icon: Clock },
  resolved: { label: 'Rezolvat', color: 'bg-emerald-500 text-white', icon: Clock },
  closed: { label: 'Inchis', color: 'bg-slate-500 text-white', icon: Clock },
  rejected: { label: 'Respins', color: 'bg-red-500 text-white', icon: Clock },
  transformed: { label: 'Transformat', color: 'bg-cyan-500 text-white', icon: Clock }
};

const TicketStatusTimeline = ({ statusHistory }) => {
  if (!statusHistory?.length) return null;

  return (
    <Card data-testid="status-timeline-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Clock className="w-4 h-4 text-slate-500" /> Istoric Status
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative pl-6">
          <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-slate-200"></div>
          <div className="space-y-4">
            {[...statusHistory].reverse().map((entry, idx) => {
              const cfg = STATUS_CONFIG[entry.status] || STATUS_CONFIG.open;
              const isFirst = idx === 0;
              return (
                <div key={idx} className="relative flex gap-3" data-testid={`timeline-entry-${idx}`}>
                  <div className={`absolute -left-6 top-0.5 w-[22px] h-[22px] rounded-full flex items-center justify-center ring-2 ring-white ${isFirst ? cfg.color : 'bg-slate-100'}`}>
                    <Clock className={`w-3 h-3 ${isFirst ? 'text-white' : 'text-slate-500'}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <Badge className={`text-xs ${isFirst ? cfg.color : 'bg-slate-100 text-slate-600'}`}>{cfg.label}</Badge>
                      {entry.previous_status && (
                        <span className="text-xs text-slate-400">de la {STATUS_CONFIG[entry.previous_status]?.label || entry.previous_status}</span>
                      )}
                    </div>
                    <div className="flex items-center gap-2 mt-1 text-xs text-slate-500">
                      <span>{new Date(entry.changed_at).toLocaleString('ro-RO')}</span>
                      {entry.changed_by_name && (
                        <><span className="text-slate-300">|</span><span className="font-medium text-slate-600">{entry.changed_by_name}</span></>
                      )}
                    </div>
                    {entry.notes && <p className="text-xs text-slate-500 mt-1 italic">"{entry.notes}"</p>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TicketStatusTimeline;
